module.exports = __webpack_public_path__ + "static/media/Password.4fcab5e2.svg";